// extracted by mini-css-extract-plugin
export default {"button":"button_button__I4ZID","pen":"button_pen__laSkO","trash":"button_trash__uss+X"};